import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { FileManagementUser, UserConfigService } from 'src/app/shared/services/user-config.service';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-pdf-converter',
  templateUrl: './pdf-converter.component.html',
  styleUrls: ['./pdf-converter.component.scss']
})
export class PdfConverterComponent implements OnInit {
  selectedFile: File | null = null;

  SalesUsers: any[] = [];
  selectedSalesUser: number = -1;
  allUsers: FileManagementUser[] = [];

  uploadedFiles: any[] = [];
  selectedFiles: File[] = [];
  value: number = 0;
  successfullyConvertedCount: number = 0;

  selectedOption: string = 'dynamic';
  isLoading: boolean = false; // Flag to handle the loading spinner
  apiEndpoint: string = ''; // API endpoint to convert the file
  fileTypes = [
    { label: 'Auto Detection', value: 'dynamic' },
    { label: 'Subscription License', value: 'normal' },
    { label: 'Software as a Service (Quote)', value: 'znbc' },
    { label: 'Software as a Service (Bid) ', value: 'zabc' },
    { label: 'SW Renewal Quotes - DIRECT', value: 'fourth' },
    { label: 'SW Renewal Quotes - Partner', value: 'fifth' },
    { label: 'Transaction Renewal Profile Agreement', value: 'sixth' },
    { label: 'Wave 4', value: 'tabula' }
  ];



  constructor(private http: HttpClient, private messageService: MessageService , private userService : UserConfigService) { }
  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    this.userService.getFileManagementUsers().toPromise().then(response => {
      // Store the original response
      this.allUsers = response;

      // Create dropdown options with default -1 option
      this.SalesUsers = [
        {
          label: 'Auto Selected User',
          value: -1
        },
        ...response
          .filter(user => user.nameShortcut && user.nameShortcut.trim() !== '')
          .map(user => ({
            label: `${user.fullName} (${user.nameShortcut})`,
            value: user.id
          }))
      ];

      
      console.log('All users:', this.allUsers);
      console.log('Filtered users:', this.SalesUsers);
    });
  }


  // onFileSelected(event: any): void {
  //   const file = event.files[0];



  //   if (file && file.type === 'application/pdf') {
  //     this.selectedFile = file;
  //   } else {
  //     alert('Please select a valid PDF file.');
  //     event.files = [];  // Clear the file selection in case of invalid file
  //     this.selectedFile = null;
  //   }
  // }

  onFileSelected(event: any): void {
    const files = event.files;
    this.selectedFiles = files.filter((file: File) => file.type === 'application/pdf');
    this.uploadedFiles = [...this.selectedFiles]; // Initialize the displayed files

    if (this.selectedFiles.length !== files.length) {
      alert('Please select valid PDF files.');
      event.files = [];
    }
  }

  // onUpload(event: UploadEvent) {
  //   this.onFileSelected(event)
  //   // for(let file of event.files) {
  //   this.onSubmit();
  //   // }

  //   this.messageService.add({ severity: 'info', summary: 'File converted', detail: '' });
  // }


  onUpload(event: UploadEvent) {
    this.onFileSelected(event);
    this.uploadFilesSequentially();
  }
  onClear(): void {

    this.value = 0;
    this.successfullyConvertedCount = 0;
    this.uploadedFiles = [];
  }


  uploadFilesSequentially(): void {
    if (this.selectedFiles.length === 0) return;

    this.isLoading = true;
    this.value = 0;
    this.successfullyConvertedCount = 0;

    const uploadNextFile = (index: number) => {
      if (index >= this.selectedFiles.length) {
        this.isLoading = false;


        this.messageService.add({
          severity: 'info',
          summary: 'All files processed',
          detail: `${this.successfullyConvertedCount} out of ${this.selectedFiles.length} files were successfully converted.`
        });


        if (this.successfullyConvertedCount !== this.selectedFiles.length) {
          this.value = (this.successfullyConvertedCount / this.selectedFiles.length) * 100;
        } else {
          this.value = 0;
        }



        return;
      }

      const file = this.selectedFiles[index];
      const formData = new FormData();
      formData.append('file', file);
  
      let user;
    if (this.selectedSalesUser === -1) {
      const email = sessionStorage.getItem('loginUserName'); 
      if (email) {
        user = this.allUsers.find(u => u.email === email);
      }
    } else {
      user = this.allUsers.find(user => user.id === this.selectedSalesUser);
    }
    if (user) {
      formData.append('user', JSON.stringify(user));
    }

     console.log("user"  ,user);

      this.apiEndpoint = this.getApiEndpoint();

      this.http.post(this.apiEndpoint, formData, {
        responseType: 'blob',
        observe: 'response'
      }).subscribe(
        (response) => {
          // Handle the response (e.g., download the file)
          const customerName = response.headers.get('Customer-Name') || 'Unknown Customer';
          const downloadUrl = window.URL.createObjectURL(response.body as Blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = `SBM SW Quotation – ${customerName}.docx`;
          link.click();
          window.URL.revokeObjectURL(downloadUrl);


          this.successfullyConvertedCount++;


          this.value = (this.successfullyConvertedCount / this.selectedFiles.length) * 100;


          this.messageService.add({
            severity: 'success',
            summary: 'File converted successfully',
            detail: `File "${file.name}" has been converted.`
          });

          this.uploadedFiles = this.uploadedFiles.filter((f) => f.name !== file.name);

          uploadNextFile(index + 1);
        },
        (error) => {

          this.messageService.add({
            severity: 'error',
            summary: 'File conversion failed',
            detail: `File "${file.name}" could not be converted.`
          });


          uploadNextFile(index + 1);
        }
      );
    };

    uploadNextFile(0); // Start uploading the first file
  }

  // onSubmit(): void {
  //   if (!this.selectedFile || !this.selectedOption) return;

  //   const formData = new FormData();
  //   formData.append('file', this.selectedFile);

  //   this.apiEndpoint = '';
  //   switch (this.selectedOption) {
  //     case 'normal':
  //       this.apiEndpoint = 'dataBridge/api/v1/convert1';
  //       break;
  //     case 'znbc':
  //       this.apiEndpoint = 'dataBridge/api/v1/convert2';
  //       break;
  //     case 'zabc':
  //       this.apiEndpoint = 'dataBridge/api/v1/convert3';
  //       break;
  //     case 'fourth':
  //       this.apiEndpoint = 'dataBridge/api/v1/convert4';
  //       break;
  //     case 'dynamic':
  //       this.apiEndpoint = 'dataBridge/api/v1/dynamicConvert';
  //       break;
  //     default:
  //       alert('Invalid option selected.');
  //       return;
  //   }

  //   this.isLoading = true;

  //   // Make the HTTP request with observe: 'response' to get headers
  //   this.http.post(this.apiEndpoint, formData, {
  //     responseType: 'blob',
  //     observe: 'response'  // Add this to get the full response including headers
  //   }).subscribe(
  //     (response) => {
  //       this.isLoading = false;

  //       // Get customer name from header
  //       const customerName = response.headers.get('Customer-Name') || 'Unknown Customer';

  //       // Create a URL for the blob response
  //       const downloadUrl = window.URL.createObjectURL(response.body as Blob);
  //       const link = document.createElement('a');

  //       // Set up the download link with new filename format
  //       link.href = downloadUrl;
  //       link.download = `SBM SW Quotation – ${customerName}.docx`;
  //       link.click();

  //       window.URL.revokeObjectURL(downloadUrl);
  //       this.selectedFile = null;

  //       const fileUpload = document.querySelector('p-fileUpload') as any;
  //       if (fileUpload) {
  //         fileUpload.clear();
  //       }
  //     },
  //     (error) => {
  //       this.isLoading = false;
  //       console.error('Error:', error);
  //       alert('An error occurred during the conversion process.');
  //     }
  //   );
  // }



  getApiEndpoint(): string {
    switch (this.selectedOption) {
      case 'normal':
        return 'dataBridge/api/v1/convert1';
      case 'znbc':
        return 'dataBridge/api/v1/convert2';
      case 'zabc':
        return 'dataBridge/api/v1/convert3';
      case 'fourth':
        return 'dataBridge/api/v1/convert4';
      case 'fifth':
        return 'dataBridge/api/v1/convert5';
      case 'sixth':
        return 'dataBridge/api/v1/convert6';
      case 'tabula':
        return 'dataBridge/api/v1/tabulaTypeDemo';
      case 'dynamic':
        return 'dataBridge/api/v1/dynamicConvert';
      default:
        alert('Invalid option selected.');
        return '';
    }
  }
}
